import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'components_v2/common/ImageV2';
import classNames from 'classnames';
import NotificationHooks from 'components/NotificationHooks';

import s from './NotificationHooksWraper.scss';

const NotificationHooksWraper = props => {
  const {
    data = {},
    isWapView,
    hideNotification,
    gaCategory,
    hideNotificationText,
    hideNotificationImage,
  } = props;
  const [defaultText, updateDefaultText] = useState('Subscribe');
  const text =
    data.defaultText || data.updatedText || 'Get LIVE Updates from this blog';
  data.defaultText = text;

  if (
    data.subscribeButtonText &&
    defaultText !== data.subscribeButtonText &&
    defaultText !== 'Subscribed'
  ) {
    updateDefaultText(data.subscribeButtonText);
  }
  const updatedText = () => {
    updateDefaultText('Subscribed');
  };

  return (
    <NotificationHooks
      data={data}
      updatedText={updatedText}
      isWapView={isWapView}
      gaCategory={gaCategory}
    >
      <div
        className={classNames({
          [s.hideNotification]: hideNotification,
          [s.notification]: true,
          [s.subscribed]: defaultText === 'Subscribed',
        })}
      >
        <div className={s.notificationText}>
          {!hideNotificationText && text}
          <button
            className={classNames({
              [s.default]: true,
              [s.frmiplwidget]: data.frmiplwidget,
            })}
          >
            {defaultText}
          </button>
        </div>
        {isWapView &&
          !hideNotificationImage && (
            <Image
              src="https://static.toiimg.com/thumb/msid-76278019,width-124,resizemode-4/76278019.jpg"
              alt=""
              lazyload
            />
          )}
      </div>
    </NotificationHooks>
  );
};

NotificationHooksWraper.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  hideNotification: PropTypes.bool,
  gaCategory: PropTypes.string,
};

NotificationHooksWraper.defaultProps = {
  isWapView: false,
  hideNotification: false,
  gaCategory: '',
};

export default NotificationHooksWraper;
